import type { App } from "vue";
import cache from "./cache";
import modal from "./modal";

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    // $cache: Function;
    // $modal: Function;
  }
}
export default function installPlugins(app: App) {
  // 缓存对象
  app.config.globalProperties.$cache = cache;
  // 模态框对象
  app.config.globalProperties.$modal = modal;
}
